<template>
  <div class="slide">
    <Header align="center" center="1">
      Hvorfor tar du denne testen?
    </Header>

    <div class="grid-container genderSelection employmentSelection">
      <div class="grid-x">
        <div class="small-6 colums text-right">
          <input
            v-model="why"
            id="whyHabits"
            name="why"
            type="radio"
            value="habits"
            class="ng-untouched ng-valid ng-dirty"
          /><label class="whySelection--habits text-center" for="whyHabits"
            ><span
              class="icon block m--center"
              :class="`${sex}-${employment}-habits`"
            ></span
            ><span>For å sjekke mine drikkevaner</span></label
          >
        </div>
        <div class="small-6 colums text-left">
          <input
            v-model="why"
            id="whyFun"
            name="why"
            type="radio"
            value="fun"
            class="ng-untouched ng-valid ng-dirty"
          /><label class="whySelection--fun text-center" for="whyFun"
            ><span
              class="icon block m--center"
              :class="`${sex}-${employment}-fun`"
            ></span
            ><span
              >Bare for moroskyld,<br />
              har ikke gitt helt ærlige svar</span
            ></label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../common/Header";
export default {
  components: {
    Header: Header,
  },
  computed: {
    sex: {
      get() {
        return this.$store.state.sex;
      },
    },
    employment: {
      get() {
        return this.$store.state.employment;
      },
    },
    why: {
      get() {
        if (this.$store.state.why == "") {
          this.$eventBus.$emit("allowNext", false);
        } else {
          this.$eventBus.$emit("allowNext", true);
        }

        return this.$store.state.why;
      },
      set(value) {
        this.$store.commit("setWhy", { why: value });
      },
    },
  },
};
</script>

<style lang="scss"></style>
